export const DATE_FORMAT_ODATA = 'YYYY-MM-DDTHH:mm:ss';
export const DATE_FORMAT_SAP = 'YYYYMMDD';

export const DATE_FORMAT_ISO = 'YYYY-MM-DD';
export const DATE_FORMAT_SHAREPOINT = 'MM_DD_YY';
export const DATE_FORMAT_TOR = 'MM-DD-YYYY';
export const DATE_FORMAT_FRIENDLY_WITH_WEEKDAY = 'dddd, MM/DD/YYYY';
export const DATE_FORMAT_FRIENDLY = 'MM/DD/YYYY';
export const DATE_FORMAT_SHORT_WEEKDAY_NAME = 'ddd';

export const DATE_FORMAT_SHAREPOINT_V2 = 'MM_dd_yy';
export const DATE_FORMAT_TOR_V2 = 'MM-dd-yyyy';

export const CUSTOM_MAT_DATE_FORMATS = {
  //: MatDateFormats
  parse: {
    dateInput: 'EEE (MM/dd)', // Used for parsing input values
  },
  display: {
    dateInput: 'EEE (MM/dd)', // Format displayed in the input field
    monthYearLabel: 'MMM yyyy', // Format for month/year selector
    dateA11yLabel: 'DD', // Accessibility format
    monthYearA11yLabel: 'MMMM yyyy', // Accessibility format
  },
};
